import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import TimeLineTitle from './TimeLineTitle';
import TimeLineSearchBox from './TimeLineSearchBox';
import TimeLineLists from './TimeLineLists';
import TimeLineGridLists from './TimeLineGridLists';
import TimeLinePagenation from './TimeLinePagenation';
import TimeLineToolBar from './TimeLineToolBar';
import UpdateTagsDialog from './UpdateTagsDialog';
import {
  PAGENATION_SELECT_PAGE,
  SEARCHBOX_UPDATE_SEARCH_OPTIONS,
} from '../../actions/actionTypes';
import {
  TIMELINE_SCREEN_MODE,
  PAGE_PATH,
  THUMBNAIL_TITLE_DISPLAY_MODE,
} from '../../lib/constants';
import getMultiLevelTags from '../../actions/api/tag/getMultiLevelTags';
import { isGuest } from '../../lib/tools';
import {
  disableWorkRecords,
  download,
  postUrls,
  downloadCheckResult,
} from '../../actions/timeline';
import TagSearchDialog from './TagSearchDialog';
import {
  Main,
  Block,
  Content,
  ListsWrapper,
} from './styles/TimeLienPageStyles';
import useTagSearchDialog from '../../hooks/useTagSearchDialog';

const TimeLinePage = ({
  searchBoxHeight,
  apiToken,
  innerRole,
  fullscreen,
  timelines,
  pagenation,
  searchOptions,
  searchOptionsError,
  tags,
  selectedTagIds,
  checkbox,
  timeLineScreenMode,
  companyLicenseInfo,
  currentCompanyInfo,
  calendarData,
  onOpenCalendar,
  onCloseCalendar,
  openDetail,
  dispatch,
  executeEvent,
  openUpdateTagsDialog,
  isSearchForUnsetTagOnly,
  provider,
  targetGroupId,
  groups,
  userInfo,
  flatTags,
  userGroups,
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const isGuestUser = isGuest(innerRole);
  const { showTagSearchDialog, toggleTagSearchDialog, closeTagSearchDialog } =
    useTagSearchDialog();

  const [selectedTab, setSelectedTab] = useState(
    THUMBNAIL_TITLE_DISPLAY_MODE.dateDisplay,
  );

  return (
    <Main fullScreen={fullscreen} className="timeLinePage">
      <Toaster />
      <Block>
        <TimeLineTitle
          userInfo={userInfo}
          fullScreen={fullscreen}
          timeLineScreenMode={timeLineScreenMode}
          onSwitchTimeLineScreenMode={() => {
            dispatch({ type: 'SWITCH_TIMELINE_SCREEN_MODE' });
          }}
          currentCompanyInfo={currentCompanyInfo}
          provider={provider}
        />
        <Content>
          {fullscreen && (
            <TimeLineSearchBox
              searchOptions={searchOptions}
              searchOptionsError={searchOptionsError}
              tags={tags}
              selectedTagIds={selectedTagIds}
              onSearch={option => {
                dispatch({ type: SEARCHBOX_UPDATE_SEARCH_OPTIONS, option });
              }}
              isGuestUser={isGuestUser}
              isShowSaveSearchCriteria
              calendarData={calendarData}
              onOpenCalendar={onOpenCalendar}
              onCloseCalendar={onCloseCalendar}
              onCheck={checked =>
                dispatch({ type: 'TIMELINESEARCHBOX_CHECKBOX_CHECK', checked })
              }
              isSearchForUnsetTagOnly={isSearchForUnsetTagOnly}
              provider={provider}
              groups={groups}
              hideGroupSelection={!!targetGroupId}
              flatTags={flatTags}
              searchTags={() =>
                dispatch(
                  getMultiLevelTags(
                    apiToken,
                    {
                      actionType: 'SUCCESS_API_GET_ALL_TAGS',
                      all: true,
                    },
                    targetGroupId,
                  ),
                )
              }
              initialTagsForSearch={() =>
                dispatch({ type: 'CLOSE_TIMELINE_TAG_SEARCH_DIALOG' })
              }
              setTags={params => {
                dispatch({ type: 'SEARCHBOX_UPDATE_SEARCH_TAGS', params });
                dispatch({
                  type: 'TIMELINESEARCHBOX_CHECKBOX_CHECK',
                  checked: false,
                });
              }}
              onChangeDisplayTag={params => {
                dispatch({ type: 'CHANGE_DISPLAY_TAG', params });
              }}
              toggleTagSearchDialog={toggleTagSearchDialog}
            />
          )}
          {fullscreen && (
            <TimeLineToolBar
              innerRole={innerRole}
              checkbox={checkbox}
              executeEvent={executeEvent}
              timelines={timelines}
              timeLineScreenMode={timeLineScreenMode}
              onCheck={(value, checked) => {
                dispatch({
                  type: 'TIMELINELISTS_CHECKBOX_CHECK',
                  value,
                  checked,
                });
              }}
              onUpdateExecuteEvent={e => {
                dispatch({
                  type: 'UPDATE_EXECUTE_EVENT',
                  executeEvent: e.target.value,
                });
              }}
              onDownloadClick={() => {
                if (checkbox.ids.length > 0) {
                  download(dispatch, apiToken, checkbox.ids, targetGroupId);
                }
              }}
              onDownloadCheckResultClick={() => {
                if (checkbox.ids.length > 0) {
                  downloadCheckResult(dispatch, apiToken, checkbox.ids);
                }
              }}
              onUpdateTagsClick={() => {
                if (checkbox.ids.length > 0) {
                  dispatch({ type: 'OPEN_UPDATE_TAGS_DIALOG' });
                }
              }}
              onDataDeleteClick={params => {
                if (checkbox.ids.length > 0) {
                  disableWorkRecords(dispatch, apiToken, formatMessage, params);
                }
              }}
              onPostUrlsClick={() => {
                if (checkbox.ids.length > 0) {
                  postUrls(dispatch, apiToken, checkbox.ids);
                }
              }}
              isShowDownload
              isShowDownloadCheckResult
              isShowEditTag
              isShowDelete
              provider={provider}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
            />
          )}
          <ListsWrapper searchBoxHeight={searchBoxHeight}>
            {timeLineScreenMode &&
            timeLineScreenMode === TIMELINE_SCREEN_MODE.list ? (
              <TimeLineLists
                fullscreen={fullscreen}
                noGroupSelected={!targetGroupId}
                timelines={timelines}
                searchOptions={searchOptions}
                checkbox={checkbox}
                companyLicenseInfo={companyLicenseInfo}
                userGroups={userGroups}
                openDetail={id => {
                  const previous = fullscreen
                    ? provider.pathName + PAGE_PATH.DS_TIMELINE
                    : PAGE_PATH.DS_ROOT;
                  openDetail(id, { previous, searchOptions });
                }}
                onCheck={(value, checked) =>
                  dispatch({
                    type: 'TIMELINELISTS_CHECKBOX_CHECK',
                    value,
                    checked,
                  })
                }
                onSort={sortColumn =>
                  dispatch({ type: 'TIMELINELISTS_CHANGE_SORT', sortColumn })
                }
                provider={provider}
              />
            ) : (
              <TimeLineGridLists
                openDetail={id => openDetail(id, { searchOptions })}
                innerRole={innerRole}
                fullscreen={fullscreen}
                timelines={timelines}
                searchOptions={searchOptions}
                checkbox={checkbox}
                companyLicenseInfo={companyLicenseInfo}
                onCheck={(value, checked) =>
                  dispatch({
                    type: 'TIMELINELISTS_CHECKBOX_CHECK',
                    value,
                    checked,
                  })
                }
                selectedTab={selectedTab}
              />
            )}
          </ListsWrapper>
        </Content>
        <TimeLinePagenation
          pagenation={pagenation}
          searchOptions={searchOptions}
          onSelect={page => {
            dispatch({
              type: 'TIMELINELISTS_CHECKBOX_CHECK',
              value: 'all',
              checked: false,
            });
            dispatch({ type: PAGENATION_SELECT_PAGE, page });
          }}
        />
        {openUpdateTagsDialog && <UpdateTagsDialog checkbox={checkbox} />}
        {/* ここにTagSearchDialogを入れる */}
        {showTagSearchDialog && (
          <TagSearchDialog
            tags={flatTags}
            selectedTagIds={selectedTagIds}
            onClose={() => closeTagSearchDialog()}
            select={params => {
              dispatch({ type: 'SEARCHBOX_UPDATE_SEARCH_TAGS', params });
              dispatch({
                type: 'TIMELINESEARCHBOX_CHECKBOX_CHECK',
                checked: false,
              });
              closeTagSearchDialog();
            }}
          />
        )}
      </Block>
    </Main>
  );
};

TimeLinePage.propTypes = {
  searchBoxHeight: PropTypes.number.isRequired,
  apiToken: PropTypes.string.isRequired,
  innerRole: PropTypes.number.isRequired,
  fullscreen: PropTypes.bool.isRequired,
  timelines: PropTypes.array.isRequired,
  pagenation: PropTypes.object.isRequired,
  searchOptions: PropTypes.object.isRequired,
  searchOptionsError: PropTypes.object.isRequired,
  tags: PropTypes.object.isRequired,
  selectedTagIds: PropTypes.array.isRequired,
  checkbox: PropTypes.object.isRequired,
  companyLicenseInfo: PropTypes.object.isRequired,
  currentCompanyInfo: PropTypes.object.isRequired,
  calendarData: PropTypes.object.isRequired,
  onOpenCalendar: PropTypes.func.isRequired,
  onCloseCalendar: PropTypes.func.isRequired,
  openDetail: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  timeLineScreenMode: PropTypes.number.isRequired,
  executeEvent: PropTypes.string.isRequired,
  openUpdateTagsDialog: PropTypes.bool.isRequired,
  isSearchForUnsetTagOnly: PropTypes.bool.isRequired,
  provider: PropTypes.object.isRequired,
  targetGroupId: PropTypes.string.isRequired,
  groups: PropTypes.array.isRequired,
  userInfo: PropTypes.object.isRequired,
  flatTags: PropTypes.array.isRequired,
  userGroups: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  timeLineScreenMode: state.main.timeLineScreenMode,
  executeEvent: state.timeline.executeEvent,
  openUpdateTagsDialog: state.timeline.openUpdateTagsDialog,
  isSearchForUnsetTagOnly: state.timeline.searchOptions.isSearchForUnsetTagOnly,
  flatTags: state.timeline.flatTags,
});

export default connect(mapStateToProps)(TimeLinePage);
